import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { PasswordValidator } from '../../utils/password-validator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, DialogService, LanguageService } from '../../services';
import { LoginService } from '../login/login.service';
import * as _ from 'lodash';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

@Component({
  selector: 'esc-change-password-challenge',
  templateUrl: './change-password-challenge.component.html',
  styleUrls: ['./change-password-challenge.component.scss']
})
export class ChangePasswordChallengeComponent implements OnInit {
  public show: any = {
    old: false,
    confirm: false,
    password: false
  };
  public updatePasswordForm: FormGroup;
  // public loading = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ChangePasswordChallengeComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { checkOldPassword: boolean, oldPassword: string, temporaryPassword?: string },
    private authService: AuthService,
    private loginService: LoginService,
    private dialogService: DialogService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.updatePasswordForm = this.fb.group({
      password: [null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(60),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`])[A-Za-z\d\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`]{0,}/)
        ])
      ],
      confirmPassword: [null, Validators.required],
      oldPassword: this.data?.checkOldPassword
        ? [this.data.oldPassword, [Validators.required, Validators.minLength(8)]]
        : [this.data.oldPassword]
    }, {
      validator: PasswordValidator.matchPassword
    });

    this.setupPasswordValidation();
  }

  private setupPasswordValidation() {
    this.updatePasswordForm.get('password').valueChanges.subscribe(() => {
      this.updatePasswordForm.get('confirmPassword').updateValueAndValidity({ emitEvent: false });
    });

    this.updatePasswordForm.get('confirmPassword').valueChanges.subscribe(() => {
      this.updatePasswordForm.get('password').updateValueAndValidity({ emitEvent: false });
    });
  }

  onSubmit() {
    if (this.updatePasswordForm.invalid) return;

    const { oldPassword, password } = this.updatePasswordForm.value;
    // this.loading = true;

    const cognitoUser = this.authService.userPool.getCurrentUser();

    if (this.data.temporaryPassword && (this.data.temporaryPassword === this.updatePasswordForm.get('password')?.value)) {
      // this.updatePasswordForm.get('confirmPassword')?.setErrors({ invalidPassword: true });
      this.updatePasswordForm.get('password')?.setErrors({ reusedPassword: true });
      return;
    }

    if (!cognitoUser) {
      this.dialogRef.close(this.updatePasswordForm.value);
      return;
    }

    // const loadingDialog = this.dialogService.loading();

    cognitoUser.getSession((err, session: CognitoUserSession) => {
      if (err) {
        this.dialogService.openSnackBar(err.message || "Session error");
        // loadingDialog.close();
        // this.loading = false;
        return;
      }

      cognitoUser.changePassword(oldPassword, password, (err, data) => {
        // loadingDialog.close();
        // this.loading = false;

        if (err) {
          const errorMessage = _.get(err, 'message', 'Error changing password')
          console.log("ERROR: ", errorMessage);

          if (errorMessage.toLowerCase().includes('has previously been used')) {
            // this.updatePasswordForm.get('confirmPassword')?.setErrors({ invalidPassword: true });
            this.updatePasswordForm.get('password')?.setErrors({ reusedPassword: true });
          } else if (errorMessage.toLowerCase().includes('exceeded')) {
            this.dialogService.openSnackBar('Too many password change attempts. Please try again in 1 hour.');
          } else {
            this.updatePasswordForm.get('oldPassword')?.setErrors({ invalidPassword: true });
            this.updatePasswordForm.get('confirmPassword')?.setErrors({ invalidPassword: true });
            this.updatePasswordForm.get('password')?.setErrors({ invalidPassword: true });
            this.dialogService.openSnackBar(errorMessage);
          }
          return;
        }

        this.loginService.updateLastChangePasswordDate({}).subscribe(() => {
          this.dialogService.openSnackBar(
            this.languageService.getTranslation("MSG_RELOGIN_NEW_PASSWORD", {})
          );
          this.dialogRef.close();
          this.authService.logout();
        });
      });
    });
  }

  close() {
    this.dialogRef.close();
  }
}
